import { useMutation, useQueryClient, type QueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  crearTipoDocumento,
  editarTipoDocumento,
  eliminarTipoDocumento,
  type CrearTipoDocumentoInput,
  type EditarTipoDocumentoInput,
} from "../services/tipos-documento-service";

/** Invalida el listado admin Y el catálogo del picker del paso Documentos. */
function invalidar(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: qk.adminTiposDocumento });
  void qc.invalidateQueries({ queryKey: qk.tiposDocumento });
}

export function useCrearTipoDocumento(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearTipoDocumentoInput) => crearTipoDocumento(input),
    onSuccess: (tipo) => {
      toastExito({ title: `Tipo '${tipo.nombre}' creado`, message: "Disponible en el picker del paso Documentos." });
      invalidar(qc);
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEditarTipoDocumento(opts?: { onEditado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EditarTipoDocumentoInput }) => editarTipoDocumento(id, input),
    onSuccess: () => {
      toastExito({ title: "Tipo de documento actualizado", message: "Los documentos ya subidos conservan el nombre con el que se clasificaron." });
      invalidar(qc);
      opts?.onEditado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEliminarTipoDocumento() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarTipoDocumento(id),
    onSuccess: () => {
      toastExito({ title: "Tipo de documento dado de baja", message: "Quedó inactivo · los documentos ya subidos no cambian." });
      invalidar(qc);
    },
    onError: toastErrorApi,
  });
}
